import { DATE_FULL_MASK_REGEX } from '../CardDate/constants';

var formatExpiryForBackend = expiry => {
  return expiry.replace(DATE_FULL_MASK_REGEX, '/20');
};

export { formatExpiryForBackend };